// extracted by mini-css-extract-plugin
export default {"status-indicator__circle":"StatusIndicator_status-indicator__circle__TvgE2"};